import React, { useContext, useEffect, useState } from "react";
import { ChevronDownIcon, XIcon, FilterIcon, SortAscendingIcon, TrashIcon } from "@heroicons/react/solid";
import { BadgeBase, DropdownMultiHover } from "@reusejs/react";
import { Context, getSortOptions, payloadToUrl, getFilterOptions } from "services";
import { useRouter } from "next/router";
import ListGridViewToggle from "../Search/ListGridViewToggle";
import { useView } from "./context/ViewContext";

export const ClearFiltersBadge = ({ onClick }: any) => (
  <div
    className="flex items-center px-3 py-0.5 bg-red-100 text-red-800 text-xs font-medium rounded-full cursor-pointer"
    onClick={onClick}
  >
    <TrashIcon height="12" width="12" className="mr-1" />
    <span>Clear Filters</span>
  </div>
);

export default function FilterComponent() {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const [selectedTags, setSelectedTags] = useState([]);
  const { currentView, setCurrentView, setPage, setClearRangeDateSearch } = useView();

  useEffect(() => {
    // Set default filter and sort when component mounts

    // if (!searchForm.value.sort_by) {
    //   searchForm.setField("sort_by", {
    //     value: "auction_date_asc"
    //   });
    // }
    if (!searchForm.value.filter_by) {
      searchForm.setField("filter_by", {
        label: "scheduled",
        value: "dated"
      });
    }
    
    payloadToUrl(router, searchForm.value);
  }, []);


  const handleClearFilters = () => {
    searchForm.setField("asset_type", "");
    searchForm.setField("sub_asset_type", "");
    searchForm.setField("state", "");
    searchForm.setField("city", "");
    searchForm.setField("reserve_price", "");
    searchForm.setField("institutes", "");
    searchForm.setField("filter_by",{
      label: "scheduled",
      value: "dated",
    });
    searchForm.setField("sort_by", "");
    searchForm.setField("auction_start_date_unix_timestamp", "");
    setPage(1);
    setClearRangeDateSearch(true);
    payloadToUrl(router, searchForm.value);
  };

  const hasFiltersApplied = () => {
    return (
      searchForm.value.asset_type ||
      searchForm.value.sub_asset_type ||
      searchForm.value.state ||
      searchForm.value.city ||
      searchForm.value.reserve_price ||
      searchForm.value.institutes ||
      searchForm.value.filter_by.value === "private_treaty" || 
      searchForm.value.filter_by.value === "undated" || 
      searchForm.value.auction_start_date_unix_timestamp
    );
  };

  const setTags = () => {
    let tags: any = [];
    if (searchForm.value.asset_type) {
      tags.push({
        name: "asset_type",
        label: searchForm.value.asset_type.label,
        value: searchForm.value.asset_type.value,
      });
    }

    if (searchForm.value.sub_asset_type) {
      tags.push({
        name: "sub_asset_type",
        label: searchForm.value.sub_asset_type.label,
        value: searchForm.value.sub_asset_type.value,
      });
    }

    if (searchForm.value.state) {
      tags.push({
        name: "state",
        label: searchForm.value.state.label,
        value: searchForm.value.state.value,
      });
    }
    setSelectedTags(tags);
  };

  useEffect(() => {
    setTags();
  }, [
    searchForm.value.asset_type,
    searchForm.value.sub_asset_type,
    searchForm.value.state,
  ]);

  // console.log("search form value in filter component ", searchForm)

  return (
    <div className="hidden sm:block fixed top-[60px] left-0 right-0 z-[9] bg-white shadow-sm border-t">
      <div className="w-full mx-auto px-8 ">
        <div className="py-3 xl:px-0 bg-white overflow-visible  ">
          <div className="relative flex justify-between items-center mx-auto w-full">
            <div className="relative mr-2 flex items-center sm:divide-x divide-gray-900">
              <div className="text-blue-600 pr-3 text-sm sm:text-md">
                Showing {searchForm.value.total} Results
              </div>
              <div className=" hidden sm:block px-3 text-sm sm:text-md">Properties</div>
              <div className="px-3">
              {hasFiltersApplied() && <ClearFiltersBadge onClick={handleClearFilters} />}
              </div>
              
            </div>
            <div className="hidden sm:block sm:flex sm:items-center sm:gap-x-5">
            
            <div className="hidden lg:block"><ListGridViewToggle view={currentView} setView={setCurrentView} /></div>
            


            <DropdownMultiHover
                dropdownMultiHoverClasses={{
                  containerClasses:
                    "absolute z-20 right-0 w-56 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none rounded-md",
                }}
                label={() => (
                  <BadgeBase
                  label={"Filters"}
                  badgePrefix={<FilterIcon height="20" width="20" className="mr-1" />}
                  badgeBaseClasses={{
                    padding: "px-3 py-2",
                    backgroundColor: "bg-gray-200",
                    textColor: "text-gray-800",
                    font: "text-sm font-medium",
                    borderRadius: "rounded-md",
                  }}
                />
                )}
                items={getFilterOptions()}
                onClick={(item, index) => {
                  searchForm.setField("filter_by", {
                    label: item.label,
                    value: item.value,
                  });
                  payloadToUrl(router, searchForm.value);
                }}
              />

              <DropdownMultiHover
                dropdownMultiHoverClasses={{
                  containerClasses:
                    "absolute z-20 right-0 w-56 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  rounded-md",
                }}
                label={() => (
                  <BadgeBase
                    label={searchForm.value.sort_by?.label || "Sort by"}
                    badgePrefix={<SortAscendingIcon height="20" width="20" className="mr-1" />}
                    badgeBaseClasses={{
                      padding: "px-3 py-2",
                      backgroundColor: "bg-gray-200",
                      textColor: "text-gray-800",
                      font: "text-sm font-medium",
                      borderRadius: "rounded-md",
                    }}
                  />
                )}
                items={getSortOptions()}
                onClick={(item, index) => {
                  if (item.value === "all_properties") {
                    searchForm.setField("sort_by", {
                      label: item.label,
                      value: item.value,
                    });
                    searchForm.setField("asset_type", "");
                    searchForm.setField("sub_asset_type", "");
                    searchForm.setField("state", ""); // check here state is not getting cleared
                    searchForm.setField("city", "");
                    searchForm.setField("reserve_price", "");
                    searchForm.setField("institutes", "");
                    searchForm.setField("filter_by", "");
                    payloadToUrl(router, searchForm.value);
                  } else {
                    searchForm.setField("sort_by", {
                      label: item.label,
                      value: item.value,
                    });

                    payloadToUrl(router, searchForm.value);
                  }
                }}
              />

            </div>
          </div>
        </div>
        
        {/* {selectedTags.length > 0 && (
          <div className="flex items-center justify-between overflow-x-scroll md:overflow-visible flex-wrap px-4 xl:px-0 scrollbar-hide">
            <div className="flex-1 flex items-center">
              <div className="whitespace-nowrap mb-2 md:mb-1 md:my-4 lg:px-0 sm:py-0 sm:space-y-0 sm:grid sm:gap-x-2 sm:grid-flow-col">
                {selectedTags.map((item: any, index) => {
                  return (
                    <BadgeBase
                      key={index}
                      label={item.label}
                      badgeSuffix={
                        <XIcon
                          width="14"
                          height="14"
                          className="text-[#3F83F8] ml-2 cursor-pointer hover:text-blue-700"
                          onClick={() => searchForm.setField(item.name, "")}
                        />
                      }
                      badgeBaseClasses={{
                        padding: "px-3 py-0.5 mr-2",
                        backgroundColor: "bg-[#E1EFFE]",
                        textColor: "text-[#1E429F]",
                        font: "text-sm font-medium capitalize",
                        borderRadius: "border border-gray-300 rounded-md",
                      }}
                    />
                  );
                })}
              </div>
            </div>
            <div className="hidden md:block order-2 flex-shrink-0 sm:order-3 sm:ml-3"></div>
          </div>
        )} */}
      </div>
      <div className="border-b w-full"></div>
    </div>
  );
}
